import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FaRegEdit, FaUserAlt } from "react-icons/fa"
import { RiUserSettingsLine } from "react-icons/ri"
import { useContext, useEffect, useState } from "react"
import { DataContext } from "../../../app/providers/DataContext"
import { RiDeleteBinFill } from "react-icons/ri"
import { grupoDelete, grupoMostrar, gruposBuscar, gruposUsuariosPorGrupo } from "../api/grupos.api";
import { listaEstadosActivo, listaEstadosActivoBusqueda } from "../../../app/constants/constants-selectores";
import { IoMdAdd } from "react-icons/io"
import { BiSearch } from "react-icons/bi"

import Swal from 'sweetalert2';
import { obtenerLabel, obtenerLocalStorage } from "../../../shared/utils/funciones";
import { useMobileDetection } from "../../../shared/hooks/useMobileDetection";
import { validarAutenticacion } from "../../auth";
import { CONST_KEY_USUARIO_AUTENTICADO } from "../../../app/constants/constanst-valores";
import { CONST_CODIGO_GRUPOS_AGREGAR, CONST_CODIGO_GRUPOS_EDITAR, CONST_CODIGO_GRUPOS_ELIMINAR, CONST_CODIGO_GRUPOS_PERMISOS, CONST_CODIGO_GRUPOS_USUARIOS, CONST_RUTA_GRUPOS_AGREGAR, CONST_RUTA_GRUPOS_EDITAR, CONST_RUTA_GRUPOS_LISTAR, CONST_RUTA_GRUPOS_PERMISOS, CONST_RUTA_GRUPOS_USUARIOS, CONST_RUTA_SIN_ACCESO } from "../../../app/constants/constants-rutas-codigos";
import { rutasCodigosPrograma } from "../../../app/constants/constanst-arreglo-rutas-codigo";
import { useRefetchAlCerrarModal } from "../../../shared/hooks/useRefetchAlCerrarModal";
import { usuarioObtenerCompaniasYSucursales } from "../../usuarios";
import { TablaSkeleton } from "../../../shared/ui/TablaSkeleton";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const Grupos = () => {

  const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);

  const { listaRutasDeAcceso } = useContext(DataContext)

  const [listaCompanias, setListaCompanias] = useState<any[]>([])

  const isMobile = useMobileDetection()

  //Estados para ver si mostrar o no los botones
  const [mostrarBotonAgregar, setMostrarBotonAgregar] = useState(false)
  const [mostrarBotonEditar, setMostrarBotonEditar] = useState(false)
  const [mostrarBotonEliminar, setMostrarBotonEliminar] = useState(false)
  const [mostrarBotonGruposUsuarios, setMostrarBotonGruposUsuarios] = useState(false)
  const [mostrarBotonGruposPermisos, setMostrarBotonGruposPermisos] = useState(false)

  const { register, handleSubmit, watch, setValue } = useForm<any>({
    defaultValues: {
      estado: "A"
    }
  });

  const navigate = useNavigate()

  // ítem 15 (React Query, fase 2): el listado se sirve vía useQuery, no useState.
  // Listado simple (como Sedes): 1 fetch por watch + 1 por submit, sin ramas.
  const queryClient = useQueryClient()
  const [filtrosAplicados, setFiltrosAplicados] = useState<any>(null)

  const { data: gruposData, isFetching } = useQuery({
    queryKey: ["seg-grupos", filtrosAplicados],
    queryFn: () => gruposBuscar({ ...filtrosAplicados, token: usuarioAutenticado?.token }),
    enabled: filtrosAplicados !== null,
  })

  // Derivados (equivalentes 1:1 a listaGrupos/isLoading/buscar).
  const listaGrupos: any[] = gruposData?.grupos ?? []
  const isLoading = isFetching
  const buscar = filtrosAplicados !== null

  const onSubmitBuscar = (data) => {
    setFiltrosAplicados({ compania: data?.compania, estado: data?.estado })
    queryClient.invalidateQueries({ queryKey: ["seg-grupos"] })
  };


  const grupoAgregar = async () => {
    const rutaNavegar = CONST_RUTA_GRUPOS_AGREGAR
    const modulo = rutasCodigosPrograma.find(r => r.ruta === rutaNavegar)
    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, modulo?.codigo)

    if (validarAutenticado) {
      navigate(rutaNavegar)
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }
  }

  const grupoUsuarios = async (codigo_grupo, compania, nombre_grupo) => {

    const rutaNavegar = CONST_RUTA_GRUPOS_USUARIOS
    const modulo = rutasCodigosPrograma.find(r => r.ruta === rutaNavegar)
    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, modulo?.codigo)

    if (validarAutenticado) {
      const dataPOST = {
        codigo_grupo,
        compania,
        token: usuarioAutenticado?.token
      }

      const { status, usuarios } = await gruposUsuariosPorGrupo(dataPOST)

      if (status === 1) {
        navigate(rutaNavegar, {
          state: {
            usuarios,
            codigo_grupo,
            nombre_grupo,
            compania
          }
        })
      }
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }

  }

  const grupoPermisos = async (compania, grupo, nombreGrupo) => {
    const rutaNavegar = CONST_RUTA_GRUPOS_PERMISOS
    const modulo = rutasCodigosPrograma.find(r => r.ruta === rutaNavegar)
    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, modulo?.codigo)

    if (validarAutenticado) {
      navigate(rutaNavegar, {
        state: {
          // modulos,
          nombreGrupo,
          compania,
          grupo
        }
      })
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }

  }

  const grupoEditar = async (codGrupo, CompCod) => {

    const rutaNavegar = CONST_RUTA_GRUPOS_EDITAR
    const modulo = rutasCodigosPrograma.find(r => r.ruta === rutaNavegar)

    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, modulo?.codigo)

    if (validarAutenticado) {
      const dataPOST = {
        codigo: codGrupo,
        compania: CompCod,
        token: usuarioAutenticado?.token
      }
      const { grupo } = await grupoMostrar(dataPOST)
      navigate(rutaNavegar, {
        state: grupo
      })
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }

  }

  const optionsEliminar = (nombreGrupo) => {
    return {
      title: `¿Estás seguro de eliminar el grupo: ${nombreGrupo}?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#6c757d',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }
  }

  const grupoEliminar = (grupo, nombreGrupo) => {
    Swal.fire(optionsEliminar(nombreGrupo) as any).then(async (result) => {
      if (result.isConfirmed) {

        const dataPOST = {
          codigo: grupo,
          token: usuarioAutenticado?.token
        }

        const { status } = await grupoDelete(dataPOST)
        if (status === 1) {
          grupoBuscarActivos()
          Swal.fire(
            'Grupo eliminado',
            '',
            'success'
          )
        } else {
          Swal.fire(
            'Error al eliminar grupo',
            '',
            'success'
          )
        }
      }
    })

  }

  // Aplica los filtros actuales (watch) y fuerza re-fetch fresco. Lo usan la carga inicial,
  // el post-eliminar y el cierre de modal (invalidate = re-consulta aunque la clave no cambie).
  const grupoBuscarActivos = () => {
    setFiltrosAplicados({ estado: watch("estado") || "A", compania: watch("compania") })
    queryClient.invalidateQueries({ queryKey: ["seg-grupos"] })
  }

  const obtenerCompaniasYSucursales = async () => {

    const dataPOST = {
      token: usuarioAutenticado?.token
    }

    const { companias, sucursales } = await usuarioObtenerCompaniasYSucursales(dataPOST)
    setListaCompanias(companias)
    setValue("compania", companias?.[0]?.id)

    return {
      companias,
      sucursales
    }
  }

  useEffect(() => {
    // obtenerModulos()

    const encontradoRutaBotonAgregar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_GRUPOS_AGREGAR)
    const encontradoRutaBotonEditar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_GRUPOS_EDITAR)
    const encontradoRutaBotonEliminar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_GRUPOS_ELIMINAR)
    const encontradoRutaBotonGruposUsuarios = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_GRUPOS_USUARIOS)
    const encontradoRutaBotonGruposPermisos = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_GRUPOS_PERMISOS)

    encontradoRutaBotonAgregar ? setMostrarBotonAgregar(true) : setMostrarBotonAgregar(false)
    encontradoRutaBotonEditar ? setMostrarBotonEditar(true) : setMostrarBotonEditar(false)
    encontradoRutaBotonEliminar ? setMostrarBotonEliminar(true) : setMostrarBotonEliminar(false)
    encontradoRutaBotonGruposUsuarios ? setMostrarBotonGruposUsuarios(true) : setMostrarBotonGruposUsuarios(false)
    encontradoRutaBotonGruposPermisos ? setMostrarBotonGruposPermisos(true) : setMostrarBotonGruposPermisos(false)

  }, [listaRutasDeAcceso])

  useEffect(() => {

    const cargarDatosIniciales = async () => {
      await obtenerCompaniasYSucursales()
      grupoBuscarActivos()
    };

    cargarDatosIniciales();
    // carga inicial (una sola vez al montar)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Al cerrar un modal (agregar/editar/usuarios/permisos) se refresca el listado
  // montado de fondo, conservando los filtros actuales.
  useRefetchAlCerrarModal(CONST_RUTA_GRUPOS_LISTAR, grupoBuscarActivos)

  return (
    <div className="p-3">
      <div className="container-fluid">
        <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Grupos</h3>
        {/* Formulario */}
        <div className="tw-mb-4 tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-md tw-border tw-border-gray-100">
          <form onSubmit={handleSubmit(onSubmitBuscar)} className="row g-2">
            <div className="col-12 col-lg-7">
              <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Compañía</label>
              <select
                {...register("compania", {
                  required: true
                })}
                className="form-select form-select-sm"
                value={watch("compania")}
              >
                {
                  listaCompanias?.length > 0 && listaCompanias.map(e => (
                    <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                  ))
                }
              </select>
            </div>
            <div className="col-12 col-lg-4">
              <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">Estado</label>
              <select {...register("estado")} className="form-select form-select-sm" >
                {
                  listaEstadosActivoBusqueda?.length > 0 && listaEstadosActivoBusqueda.map(e => (
                    <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                  ))
                }
              </select>
            </div>
            <div className="col-12 col-lg-1">
              <label className="text-start tw-text-xs tw-font-semibold tw-text-gray-600 tw-mb-1 tw-block">&nbsp;</label>
              <div className={isMobile ? "text-center" : ""}>
                <button type="submit" onClick={handleSubmit(onSubmitBuscar)} style={{ cursor: 'pointer', background: 'none', border: 'none' }}>
                  <BiSearch size={25} className="color-iconos" />
                </button>
              </div>


            </div>
          </form>
        </div>
        {/* Fin formulario */}

        {
          mostrarBotonAgregar && (
            <div className="mx-auto ps-0">
              <button className='btn btn-primario btn-sm align-middle d-flex align-items-center' onClick={grupoAgregar}>
                <IoMdAdd size={18} />
                <span className="ms-1">Agregar</span>
              </button>
            </div>
          )
        }

        {/* Tabla de resultados */}
        <div className="tw-mt-2 tw-rounded-2xl tw-bg-white tw-p-3 tw-shadow-md tw-border tw-border-gray-100 tw-overflow-x-auto">
          <table className="table table-hover tw-mb-0">
            <thead className="table-light">
              <tr>
                <th scope="col" className="col text-center">Código</th>
                <th scope="col" className="col text-center">Grupo</th>
                {/* <th scope="col" className="col text-center">App</th> */}
                <th scope="col" className="col text-center">Estado</th>
                {
                  mostrarBotonGruposUsuarios && (
                    <th scope="col" className="col text-center">Usuarios</th>
                  )
                }
                {
                  mostrarBotonGruposPermisos && (
                    <th scope="col" className="col text-center">Permisos</th>
                  )
                }
                {
                  mostrarBotonEditar && (
                    <th scope="col" className="col text-center">Editar</th>
                  )
                }
                {
                  mostrarBotonEliminar && (
                    <th scope="col" className="col text-center">Eliminar</th>
                  )
                }

              </tr>
            </thead>
            <tbody className={isLoading ? "" : "tabla-fade-in"}>
              {
                (isLoading && !listaGrupos?.length) ? (
                  <TablaSkeleton rows={6} cols={5} />

                ) : (
                  listaGrupos?.length > 0 ? listaGrupos.map(m => (
                    <tr key={m?.GrupCod}>
                      <td>{m?.GrupCod}</td>
                      <td>{m?.GrupNom}</td>
                      {/* <td>{m?.modu == "" ? "NINGUNO" : m?.modu}</td> */}
                      <td>{obtenerLabel(listaEstadosActivo, m?.GrupEst)}</td>

                      {
                        mostrarBotonGruposUsuarios && (
                          <td><FaUserAlt size={23} cursor={'pointer'} className="color-iconos" onClick={() => grupoUsuarios(m?.GrupCod, m?.GrupComp, m?.GrupNom)} /></td>
                        )
                      }
                      {
                        mostrarBotonGruposPermisos && (
                          <td><RiUserSettingsLine size={23} cursor={'pointer'} className="color-iconos" onClick={() => grupoPermisos(m?.GrupComp, m?.GrupCod, m?.GrupNom)} /></td>
                        )
                      }
                      {
                        mostrarBotonEditar && (
                          <td><FaRegEdit size={23} cursor={'pointer'} className="color-iconos" onClick={() => grupoEditar(m?.GrupCod, m?.GrupComp)} /></td>
                        )
                      }
                      {
                        mostrarBotonEliminar && (

                          <td><RiDeleteBinFill size={23} cursor={'pointer'} color="#C0392B" onClick={() => grupoEliminar(m?.GrupCod, m?.GrupNom)} /></td>
                        )
                      }
                    </tr>
                  )) :
                    (
                      (buscar) ? (
                        <tr>
                          <td colSpan={"100" as any} className="text-center">No hay grupos</td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan={"100" as any} className="text-center">Realice una búsqueda</td>
                        </tr>
                      )
                    )
                )
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
